import React from 'react';

import Banner, {BannerProps, MessageLevel} from 'ui-library/banners/Banner';

export type InformationalBannerProps = Pick<BannerProps, 'children'>;

/**
 * Renders a full width informational banner with a message.
 *
 * @deprecated Please use client/ui-library/banners/InlineBanner instead
 */
export default function InformationalBanner(props: InformationalBannerProps): JSX.Element {
  return <Banner {...props} level={MessageLevel.INFORMATIONAL} />;
}
